import { create } from "zustand";

export const useVisitsStore = create((set) => ({
  visits: null,
  setVisits: (newVisits) => set({ visits: newVisits }),
}));
